export default {
  'importPayment.title': 'Import Wire',
  'importPayment.selectionHeader': 'Import Map',
  'importPayment.fileUploadFailed': 'File Upload Failed'
};
